import React from 'react';
import PropTypes from 'prop-types';
import { ButtonsRow, ButtonStyled, ReadAllBtn } from './reviewsStyles';
import abbreviateNumber from 'core/utils/abbreviateNumber';
import { WriteReviewButton } from 'listing/components';
import CaretRight from 'core/icons/CaretRight';
import { getColor } from 'core/utils';

const BottomButtons = ({ slug, currentReviewCount, totalReviews, isCustomer, handleWriteReviewClick, hasUserReviewed, forSeller }) => {
	const signedInReviewButtonText = hasUserReviewed ? 'Edit Your Review' : 'Write a Review';
	const queryParam = forSeller ? "?for=seller" : "";

	return (
		<ButtonsRow>
			{totalReviews > currentReviewCount && (
				<ReadAllBtn href={`/subscription-box/${slug}/reviews/${queryParam}`}>
					{`Read All ${abbreviateNumber(totalReviews)} Reviews`}
					<CaretRight fill={getColor("gray11")} />
				</ReadAllBtn>
			)}

			<WriteReviewButton
				slug={slug}
				onClick={handleWriteReviewClick}
				styledButton={ButtonStyled}
				themeType="antistroke"
				className="writeReviewBtn"
			>
				{isCustomer ? signedInReviewButtonText : 'Sign in to write a review'}
			</WriteReviewButton>
		</ButtonsRow>
	);
};

BottomButtons.propTypes = {
	slug: PropTypes.string.isRequired,
	totalReviews: PropTypes.number,
	currentReviewCount: PropTypes.number,
	isCustomer: PropTypes.bool,
	forSeller: PropTypes.bool,
	handleWriteReviewClick: PropTypes.func,
	hasUserReviewed: PropTypes.bool,
};

BottomButtons.defaultProps = {
	totalReviews: 0,
	testimonials: [],
	handleWriteReviewClick: () => null,
};

export default BottomButtons;
